import React from "react";
import { ValueDisplay, ValueDisplayWithLabel } from "../../../components/ValueDisplay";
import { HorizontalStackPanel } from "../../../../components/Layout/StackPanel";
import { useStyletron } from "baseui";
import { BsArrowDownRight, BsArrowUpRight } from "react-icons/bs";
import { useGetRoomsTempertures } from "./useGetRoomsTempertures";
import { LoadingView } from "../../../../components";
import { FormattedMessage } from "react-intl";


const RoomsTemperaturesAvgOnly: React.FC<{ parentId: string, resourceGroupId: string }> = (props) => {
    const [css, theme] = useStyletron();
    const { currentWeek, lastWeek, isLoading, isSuccess, hasItems, error } = useGetRoomsTempertures(props.parentId,props.resourceGroupId);
    
    const diffAvg = currentWeek.avgValue - lastWeek.avgValue;
    return (<LoadingView rows={1} isLoading={isLoading} isSucess={isSuccess} error={error}>

        {hasItems && 
            <HorizontalStackPanel $gap={theme.sizing.scale400}>
                <ValueDisplayWithLabel small value={currentWeek.avgValue} label={<FormattedMessage id="SP_Room.AvgTemp72Days" defaultMessage={'Ø (7 days)'}></FormattedMessage>} dimension="°C" />
                <HorizontalStackPanel>
                    {diffAvg < 0 && <BsArrowDownRight color={theme.colors.positive} size={theme.sizing.scale400}></BsArrowDownRight>}
                    {diffAvg > 0 && <BsArrowUpRight color={theme.colors.negative} size={theme.sizing.scale400}></BsArrowUpRight>}
                    <ValueDisplay mini color={diffAvg > 0 ? theme.colors.negative : theme.colors.positive} value={diffAvg} dimension="°C" />
                </HorizontalStackPanel>
            </HorizontalStackPanel>
        }
    </LoadingView>);
};

export default RoomsTemperaturesAvgOnly;